// @flow strict
import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'
import PlusBundles from '../../components/bespoke/PaidMonzo/PlusBundles'
import PlusInsurance from '../../components/bespoke/PaidMonzo/PlusInsurance'
import { subtitleNodeName } from '@mondough/contentful/src/richTextDecorators'
import { getLocalisedFieldsFromNode } from '@mondough/contentful'
import { locale } from '../../Global'
import FeatureGrid from '../../components/bespoke/FeatureGrid'
import { paidSubtitleSection } from '../paidThemeComponents'
import PaidFeatureDiscoveryGrid from '../../components/bespoke/PaidMonzo/PaidFeatureDiscoveryGrid'
import CustomTextAndImageWithBackground from '../../components/bespoke/PaidMonzo/CustomTextAndImageWithBackground'

export const renderPlusBundles = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}

  return (
    <PlusBundles
      bundles={bespokeContent && bespokeContent.bundles}
      features={bespokeContent && bespokeContent.features}
      icons={bespokeContent && bespokeContent.icons}
      table={bespokeContent && bespokeContent.table}
      showPremium={bespokeContent && bespokeContent.showPremium}
    >
      {node[subtitleNodeName] && paidSubtitleSection(node[subtitleNodeName])}
    </PlusBundles>
  )
}

export const renderPlusFeatures = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return <FeatureGrid features={bespokeContent && bespokeContent.features} />
}

export const renderPlusInsurance = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}

  return (
    <PlusInsurance columns={bespokeContent && bespokeContent.columns}>
      {node[subtitleNodeName] &&
        paidSubtitleSection(node[subtitleNodeName], { theme: 'editorial' })}
    </PlusInsurance>
  )
}

export const renderPaidFeatureDiscoveryGrid = (node: ContentfulNode) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return (
    <PaidFeatureDiscoveryGrid
      features={bespokeContent && bespokeContent.features}
      flags={bespokeContent && bespokeContent.flags}
    >
      {node[subtitleNodeName] &&
        paidSubtitleSection(node[subtitleNodeName], { theme: 'editorial' })}
    </PaidFeatureDiscoveryGrid>
  )
}

export const renderCustomTextAndImageWithBackground = (
  node: ContentfulNode,
) => {
  const { bespokeContent } = getLocalisedFieldsFromNode(node, locale) || {}
  return (
    <CustomTextAndImageWithBackground
      backgroundUrl={bespokeContent && bespokeContent.backgroundURL}
      imageUrl={bespokeContent && bespokeContent.imageURL}
      title={bespokeContent && bespokeContent.title}
      description={bespokeContent && bespokeContent.descriptionInHTML}
      reverse={bespokeContent && bespokeContent.reverse}
    />
  )
}
